// extracted by mini-css-extract-plugin
module.exports = {"atendimentoConsulta":"Consultar_atendimentoConsulta__3gnzL","containerPainel":"Consultar_containerPainel__2SDkS"};